export function GetLength (value:number) {
  return value.toString().length;
}
